import {HeroSlider} from "./HeroSlider";
import {Grid} from "./Grid";
import {ActivitiesFilters} from "./ActivitiesFilters";
import owlCarousel from 'owl.carousel';
import {ContactForm} from "./ContactForm";
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import "./owl-carousel";
import "./commandes";
import "./SearchFormHosting";
// import "./cookie.js";
// import "./jquery-cookies.js";

require('readmore-js');

$('.readmore-about').readmore({
    collapsedHeight: 207,
    moreLink: ' <a class="link"><span>en savoir plus</span></a>',
    lessLink: ' <a class="link"><span>en savoir moins</span></a>'

});


const header = document.getElementById('header');
const burger = document.getElementById('burger');

let open = false;
burger.addEventListener('click', () => {
    header.classList.toggle('active');
    open ?
        $('html, body').css({
            overflow: 'auto',
            height: 'auto'
        })
    :
    $('html, body').css({
        overflow: 'hidden',
        height: '100%'
    });
    open = !open
})

window.addEventListener('scroll', () => {
    if (window.scrollY > 100) {
        header.classList.add('tiny');
    } else {
        header.classList.remove('tiny');
    }
})

const navEl = header.querySelectorAll('.header__nav ul li a');
const navImages = header.querySelectorAll('.header__navBg img');

navEl.forEach((el, index) => {
    el.addEventListener('mouseenter', () => {
        navImages.forEach((elbis) => {
            elbis.classList.remove('active');
        })
        navImages[index].classList.add('active')
    })
})

const scrollDown = document.getElementById('scrollDown');

if (scrollDown) {
    let scrolloffset = 0;
    scrollDown.addEventListener('click', () => {
        window.scrollTo({
            top: window.innerHeight - scrolloffset,
            left: 0,
            behavior: 'smooth'
        });
    })
}




HeroSlider.init();
Grid.init();
ActivitiesFilters.init();
ContactForm.init();


